/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-bootstrap/datepicker/datepicker-inner.component';
const styles_DatePickerInnerComponent:any[] = ([] as any[]);
export const RenderType_DatePickerInnerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DatePickerInnerComponent,data:{}});
function View_DatePickerInnerComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'div',[['class',
      'well well-sm bg-faded p-a card'],['role','application']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n    ']))],(null as any),
      (null as any));
}
export function View_DatePickerInnerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DatePickerInnerComponent_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.DatePickerInnerComponent = _v.component;
    const currVal_0:any = _co.datepickerMode;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_DatePickerInnerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datepicker-inner',
      ([] as any[]),(null as any),(null as any),(null as any),View_DatePickerInnerComponent_0,
      RenderType_DatePickerInnerComponent)),i0.ɵdid(638976,(null as any),0,i2.DatePickerInnerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const DatePickerInnerComponentNgFactory:i0.ComponentFactory<i2.DatePickerInnerComponent> = i0.ɵccf('datepicker-inner',
    i2.DatePickerInnerComponent,View_DatePickerInnerComponent_Host_0,{datepickerMode:'datepickerMode',
        startingDay:'startingDay',yearRange:'yearRange',minDate:'minDate',maxDate:'maxDate',
        minMode:'minMode',maxMode:'maxMode',showWeeks:'showWeeks',formatDay:'formatDay',
        formatMonth:'formatMonth',formatYear:'formatYear',formatDayHeader:'formatDayHeader',
        formatDayTitle:'formatDayTitle',formatMonthTitle:'formatMonthTitle',onlyCurrentMonth:'onlyCurrentMonth',
        shortcutPropagation:'shortcutPropagation',customClass:'customClass',monthColLimit:'monthColLimit',
        yearColLimit:'yearColLimit',dateDisabled:'dateDisabled',initDate:'initDate',
        activeDate:'activeDate'},{selectionDone:'selectionDone',update:'update',activeDateChange:'activeDateChange'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci1pbm5lci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci1pbm5lci5jb21wb25lbnQuZC50cyIsIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvbmcyLWJvb3RzdHJhcC9kYXRlcGlja2VyL2RhdGVwaWNrZXItaW5uZXIuY29tcG9uZW50LmQudHMuRGF0ZVBpY2tlcklubmVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAvZGF0ZXBpY2tlci9kYXRlcGlja2VyLWlubmVyLmNvbXBvbmVudC5kLnRzLkRhdGVQaWNrZXJJbm5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgKm5nSWY9XCJkYXRlcGlja2VyTW9kZVwiIGNsYXNzPVwid2VsbCB3ZWxsLXNtIGJnLWZhZGVkIHAtYSBjYXJkXCIgcm9sZT1cImFwcGxpY2F0aW9uXCIgPjwhLS0mbHQ7ISZuZGFzaDtuZy1rZXlkb3duPVwia2V5ZG93bigkZXZlbnQpXCImbmRhc2g7Jmd0Oy0tPlxuICAgICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAgIDwvZGl2PlxuICAiLCI8ZGF0ZXBpY2tlci1pbm5lcj48L2RhdGVwaWNrZXItaW5uZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0NJO01BQUE7TUFBQSw0Q0FBaUo7YUFDL0ksa0JBQXlCOzs7O29CQUYvQiwyQ0FDSTtNQUFBO2FBQUE7VUFBQSx3QkFFTTs7SUFGRDtJQUFMLFdBQUssU0FBTDs7OztvQkNESjtNQUFBO3lDQUFBLFVBQUE7TUFBQTtJQUFBOzs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/ng2-bootstrap/datepicker/datepicker-inner.component.ngfactory.ts